import React from 'react';
import { FIELD_READONLY, fieldInputClass } from '../UI/DisplayField';
import PhoneInput from '../UI/PhoneInput';

const reqBorder = (filled) => filled
  ? ''
  : 'border-rose-300 dark:border-rose-700/60 focus:border-rose-500 focus:ring-rose-500/20';
const isFilled = (v) => String(v ?? '').trim() !== '';
// The shared field look; read-only ones as shown values (DisplayField).
const reqFieldCls = (readOnly, filled) => (readOnly ? `w-full ${FIELD_READONLY}` : fieldInputClass(!filled));

const OccupationInfoForm = ({
  formData,
  setFormData,
  formErrors,
  hideHeader = false,
  readOnly = false,
  onFieldFocus
}) => {
  const handleFieldFocus = (field) => {
    if (!readOnly && typeof onFieldFocus === 'function') {
      onFieldFocus(field);
    }
  };

  return (
    <div className="bg-yellow-50 dark:bg-slate-800 rounded-lg shadow p-6 text-sm form-compact">
      {!hideHeader && (
        <div className="flex items-center gap-3 mb-6">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex items-center justify-center">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <rect x="4" y="4" width="16" height="16" rx="2" />
              <path d="M9 9h6v6H9z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-900 dark:text-slate-100">Occupation Information</h3>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Occupation</label>
          <input
            type="text"
            value={formData.occupation || ''}
            readOnly={readOnly}
            onFocus={() => handleFieldFocus('occupation')}
            onChange={e => !readOnly && setFormData({ ...formData, occupation: e.target.value })}
            placeholder="Occupation"
            className={reqFieldCls(readOnly, isFilled(formData.occupation))}
            required
          />
          {!readOnly && formErrors.occupation && <p className="text-rose-500 text-xs mt-1">{formErrors.occupation}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Employer Name</label>
          <input
            type="text"
            value={formData.employer_name || ''}
            readOnly={readOnly}
            onFocus={() => handleFieldFocus('employer_name')}
            onChange={e => !readOnly && setFormData({ ...formData, employer_name: e.target.value })}
            placeholder="Employer Name"
            className={reqFieldCls(readOnly, isFilled(formData.employer_name))}
            required
          />
          {!readOnly && formErrors.employer_name && <p className="text-rose-500 text-xs mt-1">{formErrors.employer_name}</p>}
        </div>
        <div>
          <PhoneInput
            label="Employer Phone"
            value={formData.employer_phone || ''}
            onChange={(combined) => !readOnly && setFormData({ ...formData, employer_phone: combined })}
            onInputFocus={() => handleFieldFocus('employer_phone')}
            required={!readOnly}
            readOnly={readOnly}
            inputClassName={readOnly ? '' : reqBorder(isFilled(formData.employer_phone))}
            selectClassName={readOnly ? '' : reqBorder(isFilled(formData.employer_phone))}
          />
          {!readOnly && formErrors.employer_phone && <p className="text-rose-500 text-xs mt-1">{formErrors.employer_phone}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Employer Address</label>
          <input
            type="text"
            value={formData.employer_address || ''}
            readOnly={readOnly}
            onFocus={() => handleFieldFocus('employer_address')}
            onChange={e => !readOnly && setFormData({ ...formData, employer_address: e.target.value })}
            placeholder="Employer Address"
            className={reqFieldCls(readOnly, isFilled(formData.employer_address))}
            required
          />
          {!readOnly && formErrors.employer_address && <p className="text-rose-500 text-xs mt-1">{formErrors.employer_address}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Salary</label>
          <input
            type="number"
            min="0"
            step="0.01"
            value={formData.salary ?? ''}
            readOnly={readOnly}
            onFocus={() => handleFieldFocus('salary')}
            onChange={e => !readOnly && setFormData({ ...formData, salary: e.target.value })}
            placeholder="Salary"
            className={reqFieldCls(readOnly, isFilled(formData.salary))}
            required
          />
          {!readOnly && formErrors.salary && <p className="text-rose-500 text-xs mt-1">{formErrors.salary}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Payslip Number</label>
          <input
            type="text"
            value={formData.payslip_number || ''}
            readOnly={readOnly}
            onFocus={() => handleFieldFocus('payslip_number')}
            onChange={e => !readOnly && setFormData({ ...formData, payslip_number: e.target.value })}
            placeholder="Payslip Number"
            className={reqFieldCls(readOnly, isFilled(formData.payslip_number))}
            required
          />
          {!readOnly && formErrors.payslip_number && <p className="text-rose-500 text-xs mt-1">{formErrors.payslip_number}</p>}
        </div>
      </div>
    </div>
  );
};

export default OccupationInfoForm;